// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "水处理运行与检修",
      "tec": "赵海",
      "week": "1-8周",
      "add": "教学楼D座120新能"
    },
    {
      "sub": "化工设备",
      "tec": "宋文伟",
      "week": "4-11周",
      "add": "教学楼D座120新能"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "水处理药剂",
      "tec": "牛微",
      "week": "4-11周",
      "add": "教学楼D座120新能"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "能源化学",
      "tec": "董颖男",
      "week": "4-11周",
      "add": "教学楼D座120新能"
    },
    [
      {
        "sub": "水处理运行与检修",
        "tec": "赵海",
        "week": "2,4,6,8周",
        "add": "教学楼D座120新能"
      },
      {
        "sub": "化工设备",
        "tec": "宋文伟",
        "week": "5,7,9,11周",
        "add": "教学楼D座120新能"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "水处理药剂",
      "tec": "牛微",
      "week": "5,7,9,11周",
      "add": "教学楼D座120新能"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "能源化学",
      "tec": "董颖男",
      "week": "4,6,8,10周",
      "add": "教学楼D座121新能"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
